import { render, staticRenderFns } from "./SuperChallengeInfoPopup.vue?vue&type=template&id=4d45d334"
import script from "./SuperChallengeInfoPopup.vue?vue&type=script&lang=js"
export * from "./SuperChallengeInfoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports